<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footer></Footer>
  </div>
</template>

<script>
import 'normalize.css'
import Header from '@/components/Organisms/Header'
import Footer from '@/components/Organisms/Footer'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>

<style lang="scss">
$white: #fff;
$yellow: #eddb44;
$blue: #009898;

#app {
  font-family: YakuHanJP, "Noto Sans JP", "游ゴシック Medium", "游ゴシック体",
    "Yu Gothic Medium", YuGothic, "ヒラギノ角ゴ ProN",
    "Hiragino Kaku Gothic ProN", "メイリオ", Meiryo, "ＭＳ Ｐゴシック",
    "MS PGothic", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-feature-settings: "palt";
  font-feature-settings: "palt";
  letter-spacing: 0.25em;
  font-weight: 300;
  font-size: 20px;
  color: #333;
  @media screen and (min-width: 412px) and (max-width: 768px) {
    font-size: 16px;
  }
  @media screen and (max-width: 411px) {
    font-size: 16px;
  }
}

main {
  margin-top: 72px;
  @media screen and (min-width: 412px) and (max-width: 768px) {
    margin-top: 0;
  }
  @media screen and (max-width: 411px) {
    margin-top: 0;
  }
}

.container {
  width: 100%;
  margin: 160px 0;
  &__inner {
    width: 960px;
    margin: 0 auto;
    padding: 0 16px;
    &:not(:first-child) {
      margin-top: 80px;
    }
    &--min {
      width: 640px;
    }
  }
  @media screen and (min-width: 769px) and (max-width: 960px) {
    &__inner {
      width: 100%;
      padding: 0 16px;
      &--min {
        max-width: 640px;
        width: 100%;
      }
    }
  }
  @media screen and (min-width: 412px) and (max-width: 768px) {
    margin: 80px 0;
    &__inner {
      width: 100%;
      padding: 0 8px;
      &:not(:first-child) {
        margin-top: 56px;
      }
      &--min {
        max-width: 640px;
        width: 100%;
      }
    }
  }
  @media screen and (max-width: 411px) {
    margin: 80px 0;
    &__inner {
      width: 100%;
      padding: 0 8px;
      &:not(:first-child) {
        margin-top: 56px;
      }
      &--min {
        width: 100%;
      }
    }
  }
}

.contentTitle {
  font-size: 40px;
  font-weight: 900;
  line-height: 1.2;
  color: $blue;
  @media screen and (min-width: 412px) and (max-width: 768px) {
    font-size: 32px;
  }
  @media screen and (max-width: 411px) {
    font-size: 32px;
  }
  &--center {
    text-align: center;
  }
}

.subContentTitle {
  position: relative;
  padding-left: 0.8em;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.5;
  color: $blue;
  @media screen and (min-width: 412px) and (max-width: 768px) {
    font-size: 20px;
  }
  @media screen and (max-width: 411px) {
    font-size: 20px;
  }
  &::before {
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    display: block;
    width: 0.4em;
    height: 100%;
    margin-right: 0.4em;
    background-color: $blue;
  }
}

.exhibition {
  &__cont {
    width: 100%;
    margin-top: 24px;
    &--center {
      display: flex;
      justify-content: center;
    }
    &__map {
      width: 100%;
      border: solid 1px #dfdfdf;
      box-shadow: 8px 8px 0 0 rgba(238, 220, 68, 0.5);
    }
  }
  img {
    width: 100%;
    height: 100%;
    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }
  @media screen and (min-width: 769px) and (max-width: 960px) {
  }
  @media screen and (min-width: 412px) and (max-width: 768px) {
  }
  @media screen and (max-width: 411px) {
    img {
      &:not(:last-child) {
        margin-bottom: 8px;
      }
    }
  }
}

.detailTable {
  width: 100%;
  padding: 0;
  font-size: 16px;
  line-height: 1.5;
  &__item {
    display: flex;
    &:not(:first-child) {
      margin-top: 1em;
    }
    &__title {
      font-weight: bold;
    }
    &__cont {
      margin-left: 1em;
      a {
        color: $blue;
        letter-spacing: 0.1em;
        &:hover {
          color: #333;
        }
      }
    }
  }
  @media screen and (min-width: 769px) and (max-width: 960px) {
  }
  @media screen and (min-width: 412px) and (max-width: 768px) {
  }
  @media screen and (max-width: 411px) {
    &__item {
      display: flex;
      flex-direction: column;
      &:not(:first-child) {
        margin-top: 0.5em;
      }
      &__title {
        width: 100%;
      }
      &__cont {
        width: 100%;
        margin-left: 0em;
        font-size: 14px;
        br {
          display: none;
        }
      }
    }
  }
}

.button {
  cursor: pointer;
  display: block;
  width: 280px;
  padding: 16px;
  background-color: lighten($yellow, 10%);
  border: solid 2px $yellow;
  border-radius: 4px;
  text-align: center;
  font-weight: 900;
  color: $blue;
  text-decoration: none;
  letter-spacing: 0;
  transition: all 0.2s ease-out;
  &:hover {
    border: solid 2px $blue;
    background-color: lighten($yellow, 15%);
  }
}

.subButton {
  cursor: pointer;
  display: block;
  width: 240px;
  padding: 16px 24px;
  border: solid 2px $blue;
  border-radius: 4px;
  text-align: center;
  font-weight: 700;
  font-size: 16px;
  color: $blue;
  text-decoration: none;
  letter-spacing: 0;
  transition: all 0.2s ease-out;
  &:hover {
    background-color: $blue;
    color: #fff;
  }
}

::selection {
  background: $yellow;
  color: $blue;
}

//Firefox
::-moz-selection {
  background: #000;
  color: $blue;
}

@font-face {
  font-family: "YakuHanJP";
  font-style: normal;
  font-weight: 100;
  src: url("https://cdn.jsdelivr.net/npm/yakuhanjp@3.0.0/dist/fonts/YakuHanJP/YakuHanJP-Thin.eot");
  src: url("https://cdn.jsdelivr.net/npm/yakuhanjp@3.0.0/dist/fonts/YakuHanJP/YakuHanJP-Thin.woff2")
      format("woff2"),
    url("https://cdn.jsdelivr.net/npm/yakuhanjp@3.0.0/dist/fonts/YakuHanJP/YakuHanJP-Thin.woff")
      format("woff");
}

@font-face {
  font-family: "YakuHanJP";
  font-style: normal;
  font-weight: 300;
  src: url("https://cdn.jsdelivr.net/npm/yakuhanjp@3.0.0/dist/fonts/YakuHanJP/YakuHanJP-Light.eot");
  src: url("https://cdn.jsdelivr.net/npm/yakuhanjp@3.0.0/dist/fonts/YakuHanJP/YakuHanJP-Light.woff2")
      format("woff2"),
    url("https://cdn.jsdelivr.net/npm/yakuhanjp@3.0.0/dist/fonts/YakuHanJP/YakuHanJP-Light.woff")
      format("woff");
}

@font-face {
  font-family: "YakuHanJP";
  font-style: normal;
  font-weight: 400;
  src: url("https://cdn.jsdelivr.net/npm/yakuhanjp@3.0.0/dist/fonts/YakuHanJP/YakuHanJP-Regular.eot");
  src: url("https://cdn.jsdelivr.net/npm/yakuhanjp@3.0.0/dist/fonts/YakuHanJP/YakuHanJP-Regular.woff2")
      format("woff2"),
    url("https://cdn.jsdelivr.net/npm/yakuhanjp@3.0.0/dist/fonts/YakuHanJP/YakuHanJP-Regular.woff")
      format("woff");
}

@font-face {
  font-family: "YakuHanJP";
  font-style: normal;
  font-weight: 500;
  src: url("https://cdn.jsdelivr.net/npm/yakuhanjp@3.0.0/dist/fonts/YakuHanJP/YakuHanJP-Medium.eot");
  src: url("https://cdn.jsdelivr.net/npm/yakuhanjp@3.0.0/dist/fonts/YakuHanJP/YakuHanJP-Medium.woff2")
      format("woff2"),
    url("https://cdn.jsdelivr.net/npm/yakuhanjp@3.0.0/dist/fonts/YakuHanJP/YakuHanJP-Medium.woff")
      format("woff");
}

@font-face {
  font-family: "YakuHanJP";
  font-style: normal;
  font-weight: 700;
  src: url("https://cdn.jsdelivr.net/npm/yakuhanjp@3.0.0/dist/fonts/YakuHanJP/YakuHanJP-Bold.eot");
  src: url("https://cdn.jsdelivr.net/npm/yakuhanjp@3.0.0/dist/fonts/YakuHanJP/YakuHanJP-Bold.woff2")
      format("woff2"),
    url("https://cdn.jsdelivr.net/npm/yakuhanjp@3.0.0/dist/fonts/YakuHanJP/YakuHanJP-Bold.woff")
      format("woff");
}

@font-face {
  font-family: "YakuHanJP";
  font-style: normal;
  font-weight: 900;
  src: url("https://cdn.jsdelivr.net/npm/yakuhanjp@3.0.0/dist/fonts/YakuHanJP/YakuHanJP-Black.eot");
  src: url("https://cdn.jsdelivr.net/npm/yakuhanjp@3.0.0/dist/fonts/YakuHanJP/YakuHanJP-Black.woff2")
      format("woff2"),
    url("https://cdn.jsdelivr.net/npm/yakuhanjp@3.0.0/dist/fonts/YakuHanJP/YakuHanJP-Black.woff")
      format("woff");
}

*,
*:before,
*:after {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue